<template>
  <base-modal>
    <z-form ref="form" @submit.native.prevent="save">
      <z-form-group class="row">
        <div class="col-12">
          <z-form-input :rules="{ required: true }">
            <i-input v-model="form.name" :placeholder="$t('autocaller_v2.operators.skills.name')" />
          </z-form-input>
        </div>
      </z-form-group>
    </z-form>
    <i-button
      slot="footer-ok"
      type="success"
      size="large"
      :loading="is_button_loading"
      :disabled="is_button_loading"
      @click="save"
    >
      {{ $t('shared.component.button.save') }}
    </i-button>
    <template slot="footer-cancel" slot-scope="{ close }">
      <i-button size="large" @click="close()">
        {{ $t('shared.component.button.cancel') }}
      </i-button>
    </template>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import SelectType from './webhook-filter-type';
  import defaultsDeep from 'lodash-es/defaultsDeep';
  import pick from 'lodash-es/pick';
  import { ProductsService } from '@autocaller_v2/services/ProductsService';
  import { mapActions } from 'vuex';

  export default {
    components: {
      BaseModal
    },

    props: {
      id: {
        type: [Number, String],
        default: null
      },
      name: {
        type: String,
        default: ''
      }
    },

    data: () => ({
      form: {
        name: ''
      },
      items: [],
      repeat: false,
      active: true,
      is_button_loading: false
    }),

    created() {
      if (this.id) {
        this.form.name = this.name;
      }
    },

    methods: {
      ...mapActions('autocaller_v2/products/table', ['getAsyncData']),
      save: function () {
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            this.is_button_loading = true;
            const { name } = this.form;

            const request = this.id
              ? ProductsService.editProduct(this.id, { name: name.replace(/^\s+|\s+$/g, '') })
              : ProductsService.createItem({ name: name.replace(/^\s+|\s+$/g, '') });
            request
              .then((res) => this.$emit('success', res))
              .catch((e) => {
                if (e?.response?.data?.name?.includes('The name has already been taken.')) {
                  this.$noty.error(this.$t('autocaller_v2.operators.error.unique_create_project'));
                } else {
                  this.$noty.error(this.$t('autocaller_v2.operators.error.create_project'));
                }

                this.$emit('fail', e);
              })
              .finally(() => (this.is_button_loading = false));
          }
        });
      }
    }
  };
</script>
